import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sc7ewms49n: FaireBrandEntity = {
  token: "b_sc7ewms49n",
  type: "brand",
  name: "1 the Woman",
  avatarUrl:
    "https://cdn.faire.com/fastly/066489fee3a002c66f1c616a0f8f80cf539fe7ed4acb85756bd8fed8c8b4af23.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b67a0d1c3ecb4634cb5ef483c74db41d9e0099cdab0472e72fd752e522d260df.png",
  logoUrl:
    "https://cdn.faire.com/fastly/066489fee3a002c66f1c616a0f8f80cf539fe7ed4acb85756bd8fed8c8b4af23.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b67a0d1c3ecb4634cb5ef483c74db41d9e0099cdab0472e72fd752e522d260df.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 99,
  rating: 4.6,
  reviewCount: 960,
  isInsider: true,
  description:
    "Welcome to 1 the Woman-where every stitch bears witness to the beauty and strength of women!💖 ✨✨\n\nWe are dedicated to bringing you the latest trends and timeless classics straight to your doorstep. Our mission is simple yet profound: to empower women through fashion, allowing them to embrace their uniqueness with every piece they wear. 💃\n\nJoin us on a journey of self-expression and empowerment. Explore our collections, find pieces that resonate with your soul, and let your style tell your unique story. Let us together redefine fashion as a form of self-celebration and empowerment.🌟\n\n🚚 Orders are dispatched from our New York, USA base. If you have urgent requirements, we offer expedited services directly from our overseas factories. Please feel free to reach out to us for any specific needs you may have.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:27.591Z",
    importedBy: "entity-db-cli",
  },
};
